<template>
	<div id="indexpage" class=""> 
		<div class="indexcenterpage">
		<leftnav class="fl" mkcode="B" itemcode="B-QGTP"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''"> 
		<govheader></govheader>
		<div class="index_left_centerpage"> 
		<div class="index_block whitebox p-4">
			<div class="map_title_tab">
				<span class="title" @click="routerself('/allchain')">{{userdata.zsdn_version==2 ? '全国重点产业链' : '从产业图谱找企业'}}</span>
				<span class="title" :class="{ 'current': pageType == 1}" @click="pageType =1">{{userdata.currentCity.text}}推荐产业链</span>
				<span class="title" :class="{ 'current': pageType == 2}" @click="pageType =2;getCollectList()">关注的产业链</span>
				<span class="fr"><vedioTips :type="2"></vedioTips></span>
				<!-- <span class="chain-more fr" @click="routerblank('/allchain')">更多</span> -->
				<video-teaching  :type="2" seat="top"></video-teaching>
			</div> 
			<ul class="hotchain-list oh" v-show="pageType == 1">
				<li v-for="(list,index) in resdata.recommend" :key="index" @click="chainrouter1(list.chainId)" class="fl">
					<div class="imgbox"><img :src="list.image" v-bind:alt="list.chainName"></div>
						<h5 class="title">{{list.chainName}}</h5> 
				</li>
			</ul>
			<ul class="hotchain-list oh" v-show="pageType == 2">
				<li v-for="(list,index) in collectList" :key="index" @click="chainrouter1(list.chainId)" class="fl">
					<div class="imgbox"><img :src="list.image" v-bind:alt="list.chainName"></div>
						<h5 class="title">{{list.chainName}}</h5> 
				</li>
				<!-- <el-empty></el-empty> -->
			</ul>
		 </div>
			<div class="index_block  whitebox px-4">
					<div class="block_title oh">
						<h3 class="title fl">市场最新热点</h3> 
					</div>
					<ul class="hotchain-list oh">
						<li v-for="(list,index) in resdata.hotspot" @click="chainrouter1(list.chainId)" class="fl">
							<div class="imgbox"><img :src="list.image" v-bind:alt="list.chainName"></div>
								<h5 class="title">{{list.chainName}}</h5> 
						</li>
					</ul>
			</div>
	<div class="opport_market whitebox index_block">
		<div class="block_title oh">
			<h3 class="title fl">{{marketTableTitle}}</h3> 
		</div>
		<div class="opp_chain_table">
			<span v-text="showmorenode?'隐藏更多节点':'点击加载更多'" class="showmorenodebtn" @click="showmorenode=!showmorenode"></span>
			<table  border="0" cellspacing="0" cellpadding="0">
				<tr class="tac fwb tabletitle"> 
					<th class="whitebd" rowspan="2">重点节点</th>
					<th class="whitebd" rowspan="2">所属产业链</th>
					<th colspan="2" class="whitebd whitebd1">市场规模（亿元）</th>
					<th colspan="7 " class="whitebd whitebd1">市场机会评估</th>
				</tr>
				<tr class="tac tabletitle1"> 
					<th>2019</th>
					<th class="whitebd">2025</th>
					<th>市场潜力</th>
					<th>发展阶段</th>
					<th>机会属性</th>
					<th>政策门槛</th>
					<th>竞争门槛</th>
					<th>技术门槛</th>
					<th>资金门槛</th>
				</tr>
				<tr v-for="(list,index) in chainnodelist" class="opprthtd" v-show=" index< 20 || showmorenode"> 
					<td>{{list.nodeName}}</td>
					<td class="title">
						<span class="curp" style="margin-left:5px;" v-for="(item,insm) in list.chainsmlist" @click="chainrouter1(item.chainid)">{{item.name}}<em v-if="insm<list.chainsmlist.length-1">、</em></span>
						</td>
					<td>{{list.market}}</td>
					<td>{{list.marketForecast}}</td> 
					<td class="stargrade">
						<img src="../../assets/starfull.png" alt="" v-for="item in list.marketPotential">
						<img src="../../assets/star.png" alt="" v-for="item in (4-list.marketPotential)">
					</td>
					<td class="stargrade">
						<img src="../../assets/starfull.png" alt="" v-for="item in list.developState">
						<img src="../../assets/star.png" alt="" v-for="item in (4-list.developState)">
					</td>
					<td class="stargrade">
						<img src="../../assets/starfull.png" alt="" v-for="item in list.chanceAttrib">
						<img src="../../assets/star.png" alt="" v-for="item in (4-list.chanceAttrib)">
					</td>
					<td class="stargrade">
						<img src="../../assets/starfull.png" alt="" v-for="item in list.policyThreshold">
						<img src="../../assets/star.png" alt="" v-for="item in (4-list.policyThreshold)">
					</td>
					<td class="stargrade">
						<img src="../../assets/starfull.png" alt="" v-for="item in list.competeThreshold">
						<img src="../../assets/star.png" alt="" v-for="item in (4-list.competeThreshold)">
					</td>
					<td class="stargrade">
						<img src="../../assets/starfull.png" alt="" v-for="item in list.techThreshold">
						<img src="../../assets/star.png" alt="" v-for="item in (4-list.techThreshold)">
					</td>
					<td class="stargrade">
						<img src="../../assets/starfull.png" alt="" v-for="item in list.fundsThreshold">
						<img src="../../assets/star.png" alt="" v-for="item in (4-list.fundsThreshold)">
					</td>
				</tr>
			</table>
		</div> 
	</div> 
	<div class="opport_market  whitebox index_block">
		<div class="block_title oh">
			<h3 class="title fl">相关重点产业上市公司投资项目</h3> 
		</div>
		<table  border="0" cellspacing="0" cellpadding="0">
			<tr class="tac fwb tabletitle">
				<th class="whitebd">时间</th>
				<th class="whitebd">投资企业</th>
				<th  class="whitebd whitebd1">投资金额（万元）</th>
				<th  class="whitebd whitebd1">投资区域</th>
				<th  class="whitebd whitebd1">项目名称</th>
			</tr> 
			<tr v-for="(list,index) in resdata.invest" class="opprthtd"> 
				 <td>{{list.date}}</td>
				 <td><span class="curp" :data="list.stockCode" @click="companyrouter(2,'/enterprises',list.stockCode)">{{list.title}}</span></td>
				 <td>{{list.money}}</td>
				 <td>{{list.area}}</td>
				 <td>{{list.projectName}}</td>
			</tr>
		</table>  
	</div>
	<div class="  index_block oh opport_companylist">
		<div class="whitebox"> 
			<h3 class="title">营收最高的上市公司</h3> 
			<div class="index_comlist">
				<span class="span-link" v-for="item in resdata.businessIncome" :data="item.stockCode" @click="companyrouter(2,'/enterprises',item.stockCode)">{{item.title}}</span>
			</div>
		</div>
		<div class="whitebox">
			<h3 class="title">利润最高的上市公司</h3>
			<div class="index_comlist">
				<span class="span-link" style="text-overflow：ellipsis;" v-for="item in resdata.operatingProfit" @click="companyrouter(2,'/enterprises',item.stockCode)" :data="item.stockCode">{{item.title}}</span>
			</div>
		</div> 
	</div>
	<div class="opport_market  whitebox index_block">
		<div class="block_title oh">
			<h3 class="title fl">相关重点产业拿地项目</h3> 
		</div>
		<table  border="0" cellspacing="0" cellpadding="0">
			<tr class="tac fwb tabletitle">
				<th class="whitebd">时间</th>
				<th class="whitebd">行政区域</th>
				<th class="whitebd">项目名称</th>
				<th  class="whitebd whitebd1">总面积(亩)</th>
				<th  class="whitebd whitebd1">总金额(万元)</th>
				<th  class="whitebd whitebd1">土地用途</th>
				<th  class="whitebd whitebd1">土地使用权人</th>
			</tr>  
			<tr v-for="(list,index) in resdata.land" class="opprthtd">
				<td>{{list.time}}</td>
				 <td>{{list.area}}</td> 
				 <td>{{list.projectName}}</td> 
				 <td>{{list.size}}{{list.sizeUnit}}</td>
				 <td>{{list.amount}}{{list.amountUnit}}</td>
				 <td>{{list.purpose}}</td> 
				 <td><span v-if="list.owner != ''">{{list.owner}}</span><span v-if="list.owner == ''">-</span></td>
			</tr>
		</table>  
	</div> 
	</div> 
	</div> 
	</div>
	</div> 	
</template>

<script> 
	import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
	  name: 'industrial-opportunities',
	  computed: {
		...mapState({
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
		},
	 data(){
			return{
				style:{
					width:'90%',
				},
				title:"全国产业图谱",
				showmorenode:false,
				userdata:{},curWebsite:this.$api.getWebsiteType(),    
				resdata:{},
				chainnodelist:[],
				hotchainlist:[],
				recommonchain:[],
				marketopprlist:[],  
				landdatalist:[], 
				investdatalist:[],
				companylist:[],edition:0,
				marketTableTitle:"重要招商机会点",
				pageType:1,
				collectList:[],
			}
		}, 
		beforeCreate() {
			// this.bus.$emit('loading', true);
		},
		created() {
				this.$nextTick(() => {
				        // 禁用右键
				        document.oncontextmenu = new Function("event.returnValue=false");
				        // 禁用选择
				        document.onselectstart = new Function("event.returnValue=false");
				      });
		  if(this.$route.query.id){
			  this.pageType = this.$route.query.id;
			  this.pageType == 2?this.getCollectList():'';
		  }
			var _this=this; 
			this.userdata = this.getuseriformation();
			this.bus.$emit('loading', true);
		},
	 mounted() { 
			if(this.curWebsite.type == 4 || this.curWebsite.type == 2){
			this.marketTableTitle='重要市场机会点';
			} 
			// document.getElementById('app').style.background = "#f0f3f5";
			if(this.userdata.edition<1){
				var _this=this;
				alert('升级版本后即可查看本页面,自动跳转');
				setTimeout(function(){
					_this.routerself('/totalEnterprises');
				},1000)
				return;
			}
	 	// console.log(this.$route.params.categoryid)
			var _this=this;   
			this.$axios.get(this.$api.cyl.chain.index() ).then(function(res){
				if(res.data.success){   
					_this.resdata=res.data.data; 
					_this.resdata.invest = _this.sortKey(_this.resdata.invest,'date');
					_this.resdata.land = _this.sortKey(_this.resdata.land,'time'); 
					_this.getnodelistfun(_this.resdata.nodeList); 
					setTimeout(function(){_this.bus.$emit('loading', false);},1200)
				}else{ 
						
				} 
			}).catch(function (error) { 
				// 请求失败处理 console.log(error);
			}); 
	 }, 
		methods:{
			getCollectList(){
			this.bus.$emit('loading', true);
			let _this = this;
			var ajaxurl = this.$api.cyl.collect.list() + '?type=7&pageSize=50&page=1';
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				console.log('收藏的产业链',res)
				if (res.data.success) {
					_this.collectList = res.data.list;
				} else {

				}
				_this.bus.$emit('loading', false);
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});

			},
			//按时间排序
			sortKey(array,key){
				  return array.sort(function(a,b){
				    var x = a[key];
				     var y = b[key];
				     return ((x>y)?-1:(x<y)?1:0)
				       })
				        },
			companyrouter(type,path,code){
				let routeUrl = this.$router.resolve({
						path: path,query: {type:type,id:code}
				});
				window.open(routeUrl.href, '_blank');  
			},
			chainrouter1(chainid){
				let routeUrl = this.$router.resolve({
						path: '/chain',query:{id:chainid}
				});
				window.open(routeUrl.href, '_blank');  
			},
			getnodelistfun(data){
				var newdata=[],newdata1=[];
				for(var i=0;i<data.length;i++){
					data[i].chainsmlist=[{name:data[i].chainName,chainid:data[i].chainId}];
					data[i].haseach=true;
					newdata.push(data[i]); 
				};
				for(var i=0;i<newdata.length;i++){ 
					for(var d=i+1;d<newdata.length;d++){
						if(newdata[i].nodeName == newdata[d].nodeName && newdata[d].haseach){
							newdata[i].chainsmlist.push({name:newdata[d].chainName,chainid:newdata[d].chainId}); 
							newdata[d].haseach=false;
						} 
					} 
				}
				for (var i=0;i<newdata.length;i++){
					if(newdata[i].haseach){
						newdata1.push(newdata[i]);
					}
				} 
				// console.log(newdata);
				// console.log(newdata1);
				this.chainnodelist=newdata1;
			},
			
	  
		}
	}
</script>

<style>
</style>
